// ── 認證相關 API ─────────────────────────────────────────────────────────────
// Phase C（SSO-only）：前台身份改由主網域 cvt 承載，已無本地 login/register。

import { apiFetch, API_BASE_URL } from './client';

/** 呼叫 /auth/me 確認目前 cvt 是否有效。回傳 user 資訊；未登入時 throw。 */
export const checkAuth = async (): Promise<{ id: string; username: string }> => {
  const res = await apiFetch(`${API_BASE_URL}/auth/me`);
  if (!res.ok) throw new Error('Not authenticated');
  return res.json();
};

export const logout = async () => {
  // 清除可能殘留的舊 token（Phase C 前的自簽登入產物）
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  await apiFetch(`${API_BASE_URL}/auth/logout`, { method: 'POST' });
};
